import React from "react";
import { Box, InputLabel, useTheme } from "@mui/material";

interface AvatarPanelProps {
  children?: React.ReactNode;
}

const AvatarPanel: React.FC<AvatarPanelProps> = () => {
  const theme = useTheme();
  const backgroundColor = theme.palette.primary.main;
  const inputText = "t";
  const inputColor = "black";
  return (
    <Box
      borderRadius="50%"
      justifyContent="center"
      alignItems="center"
      display="flex"
      sx={{
        backgroundColor: backgroundColor,
        height: { xs: "1.4rem", md: "2.1rem" },
        width: { xs: "1.4rem", md: "2.1rem" },
      }}
    >
      <InputLabel
        sx={{
          color: inputColor,
          width: "100%",
          height: "100%",
          marginTop: { xs: "10%", md: "10%", xl: "17%" },
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          fontSize: {
            xs: "1.3rem",
            md: "1.9rem",
            lg: "1.9rem",
            xl: "1.95rem",
          },
        }}
      >
        {inputText}
      </InputLabel>
    </Box>
  );
};

export default AvatarPanel;
